import { Input } from 'antd'
import { useState } from 'react'
import {
  // 名前がコンポーネントと重複するため
  ReportListFilters as ReportListFiltersType,
} from 'src/features/reports/listBetaFilters/types'
import { useReportListFilters } from 'src/features/reports/listBetaFilters/useReportListFilters'

const { Search } = Input

type Props = {
  filters: ReportListFiltersType
  executeSearch: ReturnType<typeof useReportListFilters>['executeSearch']
}

/**
 * レポート名を絞り込みするための入力欄
 *
 * 他の絞り込み項目と異なり、レポート名の入力項目だけは
 * DOMツリー状で別階層に配置されるデザインとなっているため、
 * 個別のコンポーネントとして切り出したもの。
 */
export const ReportListFiltersReportName = ({
  filters,
  executeSearch,
}: Props) => {
  const [reportNameFilter, setReportNameFilter] = useState(filters.reportName)

  const handleSearch = (value: string) => {
    const updatedFilters = {
      ...filters,
      reportName: value,
      page: 1, // ページをリセット
    }
    executeSearch(updatedFilters)
  }

  return (
    <Search
      allowClear
      style={{ width: '360px' }}
      onChange={e => setReportNameFilter(e.target.value)}
      placeholder="レポート名で検索"
      onSearch={handleSearch}
      value={reportNameFilter}
    />
  )
}
